import * as React from 'react';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { URL } from '../../Config/appConfig';
import { Auth, Email } from '../../Config/dataModel';
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import authState from '../../ReduxRequests/State/authState';
import { assertAllTrue, clearErrors } from '../../Util/errorUtil';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import util from '../../Util/util';
import Footer from '../Footer/Footer';
import '../../style/login.css';

const logo = require('../../resource/img/logo.svg');
const btnSpinner = require('../../resource/img/button-loading.gif');

interface ForgotPasswordProps {
    forgotPassword: (data: Email) => void,
    forgotPasswordEmailState: () => boolean,
    auth: () => Auth
}

interface ForgotPasswordState {
    email: string,
    sent: boolean,
    loading: boolean
}

class ForgotPassword extends React.Component<RouteComponentProps & ForgotPasswordProps, ForgotPasswordState> {
    public constructor(props: ForgotPasswordProps) {
        super(props);
        this.state = {
            email: (this.props.location.state && this.props.location.state.email) || '',
            sent: false,
            loading: false
        };
        this.goToLogin = this.goToLogin.bind(this);
        this.clickBack = this.clickBack.bind(this);
        this.clickSubmit = this.clickSubmit.bind(this);
        this.changeEmail = this.changeEmail.bind(this);
        this.onError = this.onError.bind(this);
    }

    public componentWillReceiveProps(nextProps: ForgotPasswordProps) {
        if (nextProps.forgotPasswordEmailState() === true) {
            this.setState({ sent: true });
        }
    }

    public goToLogin(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.props.history.push(URL.LOGIN);
    }

    public changeEmail(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        this.setState({
            email: event.target.value
        });
    }

    public clickSubmit(event: React.MouseEvent<HTMLElement> | React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        clearErrors();
        const nonBlank = assertAllTrue([
            { code: 156, hasResult: this.state.email.length > 0 },
            { code: 140, hasResult: !!util.isValidEmail(this.state.email) }
        ]);
        if (!nonBlank) { return; }

        this.setState({ loading: true });
        this.props.forgotPassword({ email: this.state.email });
    }

    public clickBack(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.props.history.push(URL.LOGIN);
    }

    public onError() {
        this.setState({ loading: false });
    }

    public render() {
        if (this.props.auth()) return (<Redirect to={URL.DASHBOARD} />);
        else {
            return (
                <div>
                    <div className="authContainer">
                        <div className="cmCenter loginContainer">
                            <button className="cmHorCenter" onClick={this.goToLogin}>
                                <img src={logo} />
                            </button>
                            <div className="cmText loginLabel authLabel">Forgot Password</div>
                            {this.state.sent ?
                                <div>
                                    <div className="cmText cmHorCenter authInfoText">
                                        A link to reset your password has been sent to your email.
                                    </div>
                                    <div className="cmHorCenter authBtnsContainer">
                                        <button className="cmBtn cmCenterBtn cmBlueBtn cmBoldText" onClick={this.clickBack}>Back to Login</button>
                                    </div>
                                </div> :
                                <div>
                                    <div className="cmText authInfoText">
                                        Enter the email address linked to your account below and we'll
                                        send you an email containing a link that will help you create a new password.
                                    </div>
                                    <form onSubmit={this.clickSubmit}>
                                        <div className="loginArea">
                                            <input className="cmLabel cmText cmInput loginInput" type="text"
                                                placeholder="Email"
                                                value={this.state.email} onChange={this.changeEmail} />
                                        </div>
                                        <ErrorHandler onError={this.onError} />
                                        <div className="cmBtnsContainer">
                                            <div className="cmBtnWrapper">
                                                <button type="button" className="cmBtn cmGreyBtn cmBoldText"
                                                    disabled={this.state.loading} onClick={this.clickBack}>Back
                                                </button>
                                            </div>
                                            <div className="cmBtnWrapper">
                                                <button className="cmBtn cmBlueBtn cmBoldText" onClick={this.clickSubmit}
                                                    disabled={this.state.loading}>
                                                    <span className="cmBtnWithSpinner">Submit</span>
                                                    {this.state.loading && <img className="cmBtnSpinner" src={btnSpinner} />}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>}
                        </div>
                    </div>
                    <div className="authFooter"><Footer/></div>
                </div>
            );
        }
    }
}

export default withRouter(connect(authState, authDispatch)(ForgotPassword));



// WEBPACK FOOTER //
// ./src/Components/Auth/ForgotPassword.tsx